// PricingData.tsx
import { PricingSectionData } from "./pricing";
import { TFunction } from "i18next";

export const getMeetingRoomsData = (t: TFunction): PricingSectionData => ({
  cards: [
    {
      id: "sala-riunioni",
      title: t("meetingRooms.salaRiunioni.title"),
      description: t("meetingRooms.salaRiunioni.description"),
      price: t("common.contactUs"),
      starting_at: false,
      capacity: t("meetingRooms.salaRiunioni.capacity"),
      location: t("meetingRooms.salaRiunioni.location"),
      features: [],
      imageUrl: "/spazicoworking/salariunioni.jpg",
      ctaText: t("meetingRooms.salaRiunioni.ctaText"),
      type: "spazio",
    },
    {
      id: "sala-formazione",
      title: t("meetingRooms.salaFormazione.title"),
      description: t("meetingRooms.salaFormazione.description"),
      price: t("common.contactUs"),
      starting_at: false,
      capacity: t("meetingRooms.salaFormazione.capacity"),
      location: t("meetingRooms.salaFormazione.location"),
      features: [],
      imageUrl: "/spazicoworking/salaformazione.png",
      ctaText: t("meetingRooms.salaFormazione.ctaText"),
      type: "spazio",
    },
  ],
});

export const getCoworkingData = (t: TFunction): PricingSectionData => ({
  cards: [
    {
      id: "daily-pass",
      title: t("coworking.dailyPass.title"),
      description: t("coworking.dailyPass.description"),
      originalPrice: "€ 10,00",
      price: "€ 5,00",
      starting_at: true,
      features: t("coworking.dailyPass.features", {
        returnObjects: true,
      }) as string[],
      isSpecialOffer: true,
      specialOfferText: t("coworking.dailyPass.specialOfferText"),
      imageUrl: "/spazicoworking/cowo.jpg",
      ctaText: t("coworking.dailyPass.ctaText"),
      fondazioneNote: true,
    },
    {
      id: "voucher-10-pass",
      title: t("coworking.voucher10Pass.title"),
      description: t("coworking.voucher10Pass.description"),
      originalPrice: "€ 90,00",
      price: "€ 45,00",
      starting_at: true,
      features: t("coworking.voucher10Pass.features", {
        returnObjects: true,
      }) as string[],
      isSpecialOffer: true,
      specialOfferText: t("coworking.voucher10Pass.specialOfferText"),
      imageUrl: "/spazicoworking/cowo.jpg",
      ctaText: t("coworking.voucher10Pass.ctaText"),
      fondazioneNote: true,
    },
    {
      id: "monthly-pass",
      title: t("coworking.monthlyPass.title"),
      description: t("coworking.monthlyPass.description"),
      originalPrice: "€ 120,00",
      price: "€ 60,00",
      starting_at: true,
      features: t("coworking.monthlyPass.features", {
        returnObjects: true,
      }) as string[],
      isSpecialOffer: true,
      specialOfferText: t("coworking.monthlyPass.specialOfferText"),
      imageUrl: "/spazicoworking/cowo2.jpg",
      ctaText: t("coworking.monthlyPass.ctaText"),
      fondazioneNote: true,
    },
    {
      id: "business-pass",
      title: t("coworking.businessPass.title"),
      description: t("coworking.businessPass.description"),
      price: t("common.contactUs"),
      starting_at: false,
      features: t("coworking.businessPass.features", {
        returnObjects: true,
      }) as string[],
      imageUrl: "/spazicoworking/cowo2.jpg",
      ctaText: t("coworking.businessPass.ctaText"),
    },
  ],
});
